const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_QUOTATIONS_LIST",
  FETCH_LIST_REQUEST: "FETCH_QUOTATIONS_LIST_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_QUOTATIONS_LIST_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_QUOTATIONS_LIST_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_QUOTATIONS_LIST",
}

export default LIST_ACTION_TYPES
